<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><span class="small">NEW YORK UNIVERSITY PRESS</span><br/>New York and London<br/><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="copyright">© 2005 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Sephardic and Mizrahi Jewry: from the Golden Age of Spain to<br/>modern times / edited by Zion Zohar.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN 0-8147-9705-9 (cloth: alk. paper)<br/>ISBN 0-8147-9706-7 (pbk.: alk. paper)<br/>1. Jews—Spain—History.  2. Sephardim.  3. Jews, Oriental.<br/>I. Zohar, Zion.<br/>DS135.S7S4525     2005<br/>909′.04924046—dc22              2005001776</p>
<p class="copyright">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America</p>
<p class="copyright">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6b3c5674